import React from "react";
import styles from "./SpeechToTextHeroSection.module.css";
import demoImage from "../../../Images/9isfnw2n.png";
import { Mic, Upload } from "lucide-react";

const SpeechToTextHeroSection = () => {
    return (
        <section className={styles.hero}>
            <div className={styles.container}>
                {/* Heading */}
                <h1 className={styles.heading}>
                    Turn Speech Into Text.
                    <span>Instantly. Accurately. Reliably.</span>
                </h1>

                {/* Description */}
                <p className={styles.description}>
                    ToxBox AI converts voice into clean, searchable text in real time.
                </p>
                <p className={styles.subDescription}>
                    Meetings, interviews, lectures, calls — captured without effort.
                </p>

                {/* Actions */}
                <div className={styles.actions}>
                    <button className={styles.primaryBtn}>
                        <Mic size={18} />
                        Try Speech-to-Text Free
                    </button>

                    <button className={styles.secondaryBtn}>
                        <Upload size={18} />
                        Upload Audio File →
                    </button>
                </div>

                {/* Image Section */}
                <div className={styles.mediaWrapper}>
                    <div className={styles.imageCard}>
                        <img
                            src={demoImage}
                            alt="Speech to text preview"
                            className={styles.image}
                        />

                        {/* Floating Caption */}
                        <div className={styles.caption}>
                            <span className={styles.dot} />
                            Converting voice into clean, searchable text in real time…
                        </div>
                    </div>

                    {/* Below Image Content */}
                    <div className={styles.usage}>
                        <p className={styles.usageText}>
                            Used by creators, teams, educators, and businesses who don't waste
                            time typing.
                        </p>

                        <div className={styles.roles}>
                            <span>Creators</span>
                            <span>Teams</span>
                            <span>Educators</span>
                            <span>Businesses</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SpeechToTextHeroSection;